import React, { useState, useEffect } from "react";
import { ReactComponent as DriverIconCard } from "../../../../Assets/NewIconsForCards/DriverIcon.svg";
import { ReactComponent as ShipDocCard } from "../../../../Assets/NewIconsForCards/ShipDocOverview.svg";
import Card from "../../../Components/Card";
import { useUser } from "../../../../hooks/useUser";
import { ReactComponent as ChartIcon } from "src/Assets/NewIconsForCards/ChartIcon.svg";
import { ReactComponent as ClockIcon } from "src/Assets/NewIconsForCards/ClockIcon.svg";
import { ReactComponent as SearchIcon } from "src/Assets/NewIconsForCards/SearchIcon.svg";
export default function WXAdminHome(props) {
  const [newCards, setNewCards] = useState([]);
  const [_user, ,] = useUser();

  console.log("user", _user);
  useEffect(() => {
    let newCardArray = CardsArray.filter((card) => {
      //the find method returns the whole value based on true or false
      let foundRole = card.roles.find((role) => {
        //loop at each card roles, then check if role is in user role, return boolean from includes
        let foundinUserRoles = _user.roles.includes(role);
        //This is boolean is for find on line above
        return foundinUserRoles;
      });

      if (foundRole) {
        return card;
      }
    });

    setNewCards(newCardArray);
  }, []);

  const CardsArray = [
    {
      title: "Partner Workbench",
      text: "",
      Icon: SearchIcon,
      link: "/PartnerWorkbench",
      roles: ["Admin", "SuperAdmin", "Loader"],
    },
    {
      title: "Partner Driver",
      text: "",
      Icon: DriverIconCard,
      link: "/PartnerDriverOverview",
      roles: ["Admin", "SuperAdmin", "Loader"],
    },
    {
      title: "Shipment Document Overview",
      text: "",
      Icon: ShipDocCard,
      link: "/ShipDocOverview",
      roles: ["Admin", "SuperAdmin", "Loader"],
    },
    {
      title: "Chart",
      text: "",
      Icon: ChartIcon,
      link: "/Dashboard/WXChart",
      roles: ["Admin", "SuperAdmin", "Loader"],
    },
    {
      title: "BOL Process Time Chart",
      text: "",
      Icon: ClockIcon,
      link: "/Dashboard/WXBOLProcessTimeChart",
      roles: ["Admin", "SuperAdmin", "Loader"],
    },
  ];

  return (
    <div className="container-fluid ">
      <div className="mainContainer">
        <div className="overviewCardContainer">
          {newCards.map((record, i) => (
            <Card {...record} key={i} />
          ))}
        </div>
      </div>
    </div>
  );
}
